import styled from "styled-components"

const Column = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${props => props.crossAxis || "flex-start"};
    justify-content: ${props => props.mainAxis || "flex-start"};
`;

export default Column;